import script from "./tournament-detail-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./tournament-detail-modal.vue?vue&type=script&setup=true&lang=js"

import "./tournament-detail-modal.vue?vue&type=style&index=0&id=45341b22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45341b22"]])

export default __exports__